import { McIcon } from './icon.js'





export class McIconBoxtruck extends McIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" 
  width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"  aria-hidden="true">
  <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path>
  <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
  <circle cx="17" cy="18" r="2"></circle>
  <circle cx="7" cy="18" r="2"></circle>
</svg>
`
    super.addHTML(temp)
  }



}


if (!window.customElements.get("mc-icon-boxtruck")) {
  window.customElements.define("mc-icon-boxtruck", McIconBoxtruck)
}
